export default [
  {
    //  全能神显现作工的背景
    path: "/background-to-Almighty-God-s-work",
    name: "background-to-Almighty-God-s-work",
    component: () =>
      import("@/views/background-to-Almighty-God-s-work/index.vue"),
    meta: {
      title: "全能神显现作工的背景",
      order: 3,
      episode: "episode1",
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/background-to-Almighty-God-s-work/bg-0.jpg",
          "images/background-to-Almighty-God-s-work/bg-0-front.png",
        ],
      },
    },
  },
];
